import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "row m3 p-3" }
const _hoisted_2 = { class: "incident-form-container" }
const _hoisted_3 = { class: "dialog-content" }
const _hoisted_4 = { class: "form-group mb-3" }
const _hoisted_5 = { class: "form-actions" }
const _hoisted_6 = ["disabled"]
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { class: "form-actions" }
const _hoisted_10 = ["disabled"]
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { key: 1 }
const _hoisted_13 = { class: "form-actions" }
const _hoisted_14 = ["disabled"]
const _hoisted_15 = { key: 0 }
const _hoisted_16 = { key: 1 }
const _hoisted_17 = { class: "form-actions" }
const _hoisted_18 = ["disabled"]
const _hoisted_19 = { key: 0 }
const _hoisted_20 = { key: 1 }
const _hoisted_21 = { class: "form-actions" }
const _hoisted_22 = ["disabled"]
const _hoisted_23 = { key: 0 }
const _hoisted_24 = { key: 1 }
const _hoisted_25 = { class: "form-actions" }
const _hoisted_26 = ["disabled"]
const _hoisted_27 = { key: 0 }
const _hoisted_28 = { key: 1 }
const _hoisted_29 = { class: "form-actions" }
const _hoisted_30 = ["disabled"]
const _hoisted_31 = { key: 0 }
const _hoisted_32 = { key: 1 }
const _hoisted_33 = { class: "form-actions" }
const _hoisted_34 = ["disabled"]
const _hoisted_35 = { key: 0 }
const _hoisted_36 = { key: 1 }

import { ref, reactive, computed } from 'vue';
  import SearchSelect from '@/components/incidents/SearchSelect.vue';
  import entitiesAPI from '@/api/entitiesAPI';
  import utilsApi from '@/api/utilsApi';
  import { FormAction } from '@/types/emailTypes';
  import _ from 'lodash';

  
export default /*@__PURE__*/_defineComponent({
  __name: 'UtilsExpendeduria',
  setup(__props) {

  const formData = reactive({
      id_expendeduria: null as number | null,
    });

  const selectExpendeduria = (item: any) => {
      formData.id_expendeduria = item.id;
    };

  const expendeduriasResults = ref<any[]>([]);
  const loadingExpendedurias = ref(false);

  const submittingPdf = ref(false);
  const submittingAction = ref<FormAction | null>(null);

  const isSubmitting = computed(() => submittingPdf.value || submittingAction.value !== null);

  const feedbackMessage = reactive({
    text: '',
    type: 'success' as 'success' | 'error',
  });

  const showNotification = (text: string, type: 'success' | 'error') => {
    feedbackMessage.text = text;
    feedbackMessage.type = type;
    setTimeout(() => {
      feedbackMessage.text = '';
    }, 4000);
  };
  
  const handleExpendeduriaSearch = _.debounce(async (query: string) => {
    if (query === "") {
      expendeduriasResults.value = [];
      return
    }
    
    try {
      loadingExpendedurias.value = true;
      const response = await entitiesAPI.searchExpendeduria(query)
      expendeduriasResults.value = response.results.slice(0, 10);
    } catch (error) {
      console.error('Error buscando expendedurías:', error);
    } finally {
      loadingExpendedurias.value = false;
    }
  }, 300);
  
  
  // Envío del formulario
  const submitForm = async (action: FormAction) => {    
    if (!formData.id_expendeduria) {
      showNotification('Por favor, selecciona una expendeduría antes de enviar el formulario.', 'error');
      return;
    }
    
    try {
      if (action === 'pdf') {
        submittingPdf.value = true;
        await utilsApi.getPDF(formData.id_expendeduria);
        showNotification('PDF generado correctamente.', 'success');
      } else {
        submittingAction.value = action;
        await utilsApi.sendEmail(formData.id_expendeduria, action);
        showNotification('Correo enviado correctamente.', 'success');
      }
    } catch (error) {
      console.error('Error:', error);
      showNotification('Ocurrió un error al procesar la solicitud.', 'error');
    } finally {
      submittingPdf.value = false;
      submittingAction.value = null;
    }
  };

  
return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[16] || (_cache[16] = _createElementVNode("h1", null, "Expendeduría", -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (feedbackMessage.text)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass(['alert', feedbackMessage.type === 'success' ? 'alert-success' : 'alert-danger'])
            }, _toDisplayString(feedbackMessage.text), 3))
          : _createCommentVNode("", true),
        _createElementVNode("form", null, [
          _createElementVNode("div", _hoisted_4, [
            _cache[8] || (_cache[8] = _createElementVNode("label", { class: "form-label" }, "Expendeduría:", -1)),
            _createVNode(SearchSelect, {
              items: expendeduriasResults.value,
              loading: loadingExpendedurias.value,
              "item-text": "name",
              onSearch: _unref(handleExpendeduriaSearch),
              onSelect: selectExpendeduria,
              placeholder: "Buscar expendeduría..."
            }, null, 8, ["items", "loading", "onSearch"])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("button", {
              type: "button",
              disabled: isSubmitting.value,
              class: "btn btn-dark",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (submitForm('pdf')))
            }, [
              (isSubmitting.value)
                ? (_openBlock(), _createElementBlock("span", _hoisted_7, "Generando el PDF ..."))
                : (_openBlock(), _createElementBlock("span", _hoisted_8, "Crear PDF"))
            ], 8, _hoisted_6)
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("button", {
              type: "button",
              disabled: isSubmitting.value,
              class: "btn btn-dark",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (submitForm('credenciales')))
            }, [
              (submittingAction.value === 'credenciales')
                ? (_openBlock(), _createElementBlock("span", _hoisted_11, "Enviando el correo ..."))
                : (_openBlock(), _createElementBlock("span", _hoisted_12, "Enviar Correo Credenciales")),
              _cache[9] || (_cache[9] = _createElementVNode("span", null, null, -1))
            ], 8, _hoisted_10)
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("button", {
              type: "button",
              disabled: isSubmitting.value,
              class: "btn btn-dark",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (submitForm('credenciales-gema')))
            }, [
              (submittingAction.value === 'credenciales-gema')
                ? (_openBlock(), _createElementBlock("span", _hoisted_15, "Enviando el correo ..."))
                : (_openBlock(), _createElementBlock("span", _hoisted_16, "Enviar Correo Credenciales (Copia a Gema)")),
              _cache[10] || (_cache[10] = _createElementVNode("span", null, null, -1))
            ], 8, _hoisted_14)
          ]),
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("button", {
              type: "button",
              disabled: isSubmitting.value,
              class: "btn btn-dark",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (submitForm('credenciales-sepa')))
            }, [
              (submittingAction.value === 'credenciales-sepa')
                ? (_openBlock(), _createElementBlock("span", _hoisted_19, "Enviando el correo ..."))
                : (_openBlock(), _createElementBlock("span", _hoisted_20, "Credenciales + SEPA")),
              _cache[11] || (_cache[11] = _createElementVNode("span", null, null, -1))
            ], 8, _hoisted_18)
          ]),
          _createElementVNode("div", _hoisted_21, [
            _createElementVNode("button", {
              type: "button",
              disabled: isSubmitting.value,
              class: "btn btn-dark",
              onClick: _cache[4] || (_cache[4] = ($event: any) => (submitForm('recordatorio-sepa')))
            }, [
              (submittingAction.value === 'recordatorio-sepa')
                ? (_openBlock(), _createElementBlock("span", _hoisted_23, "Enviando el correo ..."))
                : (_openBlock(), _createElementBlock("span", _hoisted_24, "Enviar Correo Mandato SEPA")),
              _cache[12] || (_cache[12] = _createElementVNode("span", null, null, -1))
            ], 8, _hoisted_22)
          ]),
          _createElementVNode("div", _hoisted_25, [
            _createElementVNode("button", {
              type: "button",
              disabled: isSubmitting.value,
              class: "btn btn-dark",
              onClick: _cache[5] || (_cache[5] = ($event: any) => (submitForm('fin-mes-de-prueba')))
            }, [
              (submittingAction.value === 'fin-mes-de-prueba')
                ? (_openBlock(), _createElementBlock("span", _hoisted_27, "Enviando el correo ..."))
                : (_openBlock(), _createElementBlock("span", _hoisted_28, "Enviar Correo Fin Mes de Prueba")),
              _cache[13] || (_cache[13] = _createElementVNode("span", null, null, -1))
            ], 8, _hoisted_26)
          ]),
          _createElementVNode("div", _hoisted_29, [
            _createElementVNode("button", {
              type: "button",
              disabled: isSubmitting.value,
              class: "btn btn-dark",
              onClick: _cache[6] || (_cache[6] = ($event: any) => (submitForm('3-dias-prorroga')))
            }, [
              (submittingAction.value === '3-dias-prorroga')
                ? (_openBlock(), _createElementBlock("span", _hoisted_31, "Enviando el correo ..."))
                : (_openBlock(), _createElementBlock("span", _hoisted_32, "Enviar Correo 3 Días Prórroga")),
              _cache[14] || (_cache[14] = _createElementVNode("span", null, null, -1))
            ], 8, _hoisted_30)
          ]),
          _createElementVNode("div", _hoisted_33, [
            _createElementVNode("button", {
              type: "button",
              disabled: isSubmitting.value,
              class: "btn btn-dark",
              onClick: _cache[7] || (_cache[7] = ($event: any) => (submitForm('acceso-caducado')))
            }, [
              (submittingAction.value === 'acceso-caducado')
                ? (_openBlock(), _createElementBlock("span", _hoisted_35, "Enviando el correo ..."))
                : (_openBlock(), _createElementBlock("span", _hoisted_36, "Enviar Correo Acceso Caducado")),
              _cache[15] || (_cache[15] = _createElementVNode("span", null, null, -1))
            ], 8, _hoisted_34)
          ])
        ])
      ])
    ])
  ]))
}
}

})